module.exports = __webpack_public_path__ + "img/tablet-dark.ba09574b.svg";